module.exports = __webpack_public_path__ + "static/s6-objekt2-c5010d678817e2dc22a71569e058f72a.png";